/**
 * Minimale Logger-Abstraktion für den produktiven Frontend-Code.
 *
 * Ziel: Kein direktes `console.error`/`console.warn` im Produktionscode —
 * in einer Production-Build-Umgebung (NODE_ENV === 'production') schweigt
 * der Logger vollständig, damit keine internen Fehlerdetails in der
 * Browser-Konsole erscheinen.
 *
 * In Entwicklungsumgebungen (development, test) werden die Meldungen 1:1
 * an die Browser-Konsole weitergereicht, sodass Debugging uneingeschränkt
 * funktioniert.
 *
 * Verwendung:
 *   import { logError, logWarn } from '../utils/logger';
 *
 *   logError('Fehler beim Laden:', error);
 *   logWarn('[Guard] Legacy-Token ohne Rollen-Feld erkannt.');
 *
 * @module logger
 */

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

/**
 * Gibt eine Fehlermeldung auf der Konsole aus — nur außerhalb von Production.
 *
 * @param {...*} args - Beliebige Argumente (wie bei console.error)
 */
export const logError = (...args) => {
  if (!IS_PRODUCTION) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

/**
 * Gibt eine Warnung auf der Konsole aus — nur außerhalb von Production.
 *
 * @param {...*} args - Beliebige Argumente (wie bei console.warn)
 */
export const logWarn = (...args) => {
  if (!IS_PRODUCTION) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

/**
 * Gibt eine Info-Meldung auf der Konsole aus — nur außerhalb von Production.
 *
 * @param {...*} args - Beliebige Argumente (wie bei console.info)
 */
export const logInfo = (...args) => {
  if (!IS_PRODUCTION) {
    // eslint-disable-next-line no-console
    console.info(...args);
  }
};
